import React from "react";
import Tile from "../../display/Tile";
const KitchenSinkTiles = () => {
    const TileItems = [{ href: "#", icon: { name: "account" }, text: "Manage personal details and settings", heading: "Account" }, { onClick: () => alert("block clicked"), icon: { name: "briefcase" }, text: "Add the employers you've worked for", heading: "Employments" }];
    return /*#__PURE__*/ React.createElement("div", { className: "kitchen-sink__section" }, /*#__PURE__*/ React.createElement("h2", { id: "blocks", className: "kitchen-sink__section-heading" }, "Blocks"), /*#__PURE__*/ React.createElement("div", { className: "kitchen-sink__tile" }, /*#__PURE__*/ React.createElement("span", { className: "kitchen-sink__label" }, "Account and review blocks"), /*#__PURE__*/ React.createElement("div", { style: { display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem' } }, TileItems.map((item, index) => /*#__PURE__*/ React.createElement(Tile, Object.assign({ key: index }, item)))), /*#__PURE__*/ React.createElement("pre", { className: "kitchen-sink__code" }, /*#__PURE__*/ React.createElement("code", null, `const TileItems = [
  {
    href: "#",
    icon: { name: "account" },
    text: "Manage personal details and settings",
    heading: "Account"
  },
  {
    onClick: () => alert("block clicked"),
    icon: { name: "briefcase" },
    text: "Add the employers you've worked for",
    heading: "Employments"
  }
]

blockItems.map((item, index) => (
  <Tile key={index} {...item} />
))`))));
};
export default KitchenSinkTiles;
